module.exports = __webpack_public_path__ + "img/alert-active.a82e9d64.png";